module.exports = __webpack_public_path__ + "img/im_scrollfeature_07@2x.97302e7d.jpg";